import { Badge } from "@/components/ui/badge";

const MAP = {
  "Pendente": "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30",
  "Em Andamento": "bg-blue-500/15 text-blue-600 dark:text-blue-400 border-blue-500/30",
  "Enviada": "bg-blue-500/15 text-blue-600 dark:text-blue-400 border-blue-500/30",
  "Aprovada": "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30",
  "Rejeitada": "bg-red-500/15 text-red-600 dark:text-red-400 border-red-500/30",
  "Pendente Correção": "bg-red-500/15 text-red-600 dark:text-red-400 border-red-500/30",
  "Orçado": "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30",
  "Aprovado": "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30",
  "Executado": "bg-primary/15 text-primary border-primary/30",
  "ativo": "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30",
};

export default function StatusBadge({ status }) {
  const cls = MAP[status] || "bg-secondary text-secondary-foreground border-border";
  return <Badge variant="outline" className={`${cls} font-semibold`} data-testid={`status-${status}`}>{status}</Badge>;
}
